__turbopack_context__.v({
  "search-type-filter": "search-type-filter-module-scss-module__Ol5tFa__search-type-filter",
});
